var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { v4 as uuidv4 } from 'uuid';
import { ChartFactory } from './chartFactory';
/**
 * Represents the sparkline chart
 */
let DinapsisSparklineChart = class DinapsisSparklineChart extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * A property that is used to manage class of chartFactoryHandler
         */
        this.chartFactoryHandler = new ChartFactory();
        /**
         * A property that is used to set the height
         */
        this.height = '100%';
        /**
         * A property that is used to set the width
         */
        this.width = '100%';
        /**
         * A property that is used to create a data of ChartData.
         */
        this.data = [];
        /**
         * A property that is used to generate unique idChart
         */
        this.idChart = `chartdiv-${uuidv4()}`;
        /**
         * A property that contains the error message.
         */
        this.errorMessage = '';
        /**
         * A property that is used to save the chart
         */
        this.chart = null;
    }
    /**
     * The createRenderRoot function is a function that is called by the lit-html library to tell the
     * component where to render the html.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('data')) {
            this.loadCharts();
        }
    }
    /**
     * If the first element of the data array has a type property, assign it to typeOfSerie, otherwise
     * assign null to typeOfSerie. If the first element of the data array has a data property, and the
     * first element of that data array has a category property,
     * assign it to typeOfCategory, otherwise
     * assign null to typeOfCategory.
     * @returns An object with two properties: typeOfSerie and typeOfCategory.
     */
    getTypes() {
        var _a;
        const typeOfSerie = (_a = this.data[0].type) !== null && _a !== void 0 ? _a : null;
        let typeOfCategory = null;
        if (this.data.length > 0) {
            for (let i = 0; i < this.data.length; i += 1) {
                if (this.data[i].data.length > 0) {
                    typeOfCategory = this.data[i].data[0].category;
                    break;
                }
            }
        }
        return { typeOfSerie, typeOfCategory };
    }
    /**
     * This method loads the charts onto the page using the AmChartsBase library.
     * It loops through the `data` property, which is an array of `IChartSeries` objects,
     * and initializes a chart for each one using the `chartFactoryHandler` object.
     */
    loadCharts() {
        this.errorMessage = '';
        // Check if chart exists before proceeding
        if (this.chart)
            this.chart.destroy();
        const { typeOfSerie, typeOfCategory } = this.getTypes();
        try {
            // Create Chart Element
            this.chart = this.chartFactoryHandler.createChart(this.idChart, typeOfSerie, typeOfCategory, undefined, undefined, this.chartOptions);
            // Clears the padding
            this.chart.clearPadding(typeOfSerie);
            // Loop through the `data` property and create a chart for each `IChartSeries` object
            try {
                this.data.forEach((serie) => {
                    /**
                     * Create a new serie using the `chartFactoryHandler`
                     * object and init the `series`
                     */
                    const serieFactory = this.chartFactoryHandler.createSerie(serie, this.chart);
                    serieFactory.initSerie();
                });
            }
            catch (e) {
                this.chart.destroy();
                this.errorMessage = e.message;
                console.error(e);
            }
            this.dispatchEvent(new CustomEvent('chart-loaded', { detail: this.chart }));
        }
        catch (e) {
            this.errorMessage = e.message;
            console.error(e);
        }
    }
    /**
     * The function returns a string with the error message in a HTML string.
     * @returns An HTML with de error message.
     */
    showErrorMessage() {
        return this.errorMessage ? html `<div>${this.errorMessage}</div>` : '';
    }
    /**
     * The function returns a string of HTML that contains a div that contains the component.
     * @returns The return statement is returning the html template literal
     */
    render() {
        return html `
      <div id="${this.idChart}" style="width: ${this.width}; height: ${this.height};">
        ${this.showErrorMessage()}
      </div>
    `;
    }
};
__decorate([
    property({ type: String })
], DinapsisSparklineChart.prototype, "height", void 0);
__decorate([
    property({ type: String })
], DinapsisSparklineChart.prototype, "width", void 0);
__decorate([
    property({ type: Array })
], DinapsisSparklineChart.prototype, "data", void 0);
__decorate([
    property({ type: Object })
], DinapsisSparklineChart.prototype, "chartOptions", void 0);
__decorate([
    state(),
    property({ type: String })
], DinapsisSparklineChart.prototype, "errorMessage", void 0);
DinapsisSparklineChart = __decorate([
    customElement('dinapsis-sparkline-chart')
], DinapsisSparklineChart);
export { DinapsisSparklineChart };
//# sourceMappingURL=dinapsis-sparkline-chart.js.map